import {Multicomplete} from "./autocomplete";

export class AnimalPicker {
    constructor(container) {
        this.container = container;
        this.picker_id = this.container.id;

        this.select = document.querySelector(".linear-multiselect");
        this.acDataNames = ["individuals", "stocks", "strains", "tanks", "experimental_groups"];
        this.multicompletes = new Map(
            this.acDataNames
                .map(ac_name => [ac_name, this.container.querySelector(`.animal-picker-mcs [data-mc=${ac_name}]`)])
                .filter(([_, el]) => el) // filter empty
        );
        // Event listeners
        this.container.querySelectorAll("input.animal-select-mode").forEach((el) => {
            el.addEventListener("change", () => {
                el.closest('label').classList.toggle('is-active', el.checked);
                this.updateAnimalPicker();
            });
        });
        this.container.querySelector(".convert-to-individuals").addEventListener("click", () => this.convertToIndividuals());
        this.container.addEventListener("error", () => this.updateAnimalPicker());

        this.container.classList.add("finished");

        // init uninited autocompletes
        this.container.querySelectorAll('.multicomplete:not(.finished)').forEach(element => new Multicomplete(element))
        this.updateAnimalPicker();
    }

    updateAnimalPicker() {
        const values = Array.from(this.container.querySelectorAll("input.animal-select-mode:checked")).map(el => el.value);
        this.acDataNames.forEach((ac) => {
            let el = this.multicompletes.get(ac);
            if (!el) return;
            if (el.querySelectorAll("option").length > 0 || el.classList.contains("loading")) {
                // Put the container on top of parent
                const elContainer = el.closest(".mc-container");
                elContainer.classList.toggle("is-hidden", false);
                const mcSelectInput = this.container.querySelector(`.linear-multiselect input[value=${ac}]`)
                mcSelectInput.closest("label").classList.toggle("is-active", true);
                mcSelectInput.checked = true;
            } else if (values.includes(ac) || this.container.querySelector(`.${el.name}-error`).innerText) {
                el.closest(".mc-container").classList.toggle("is-hidden", false);
                const mcSelectInput = this.container.querySelector(`.linear-multiselect input[value=${ac}]`)
                mcSelectInput.closest("label").classList.toggle("is-active", true);
            } else {
                el.closest(".mc-container").classList.toggle("is-hidden", true);
            }
        });
    }

    // updateAnimalPicker() {
    //     const values = Array.from(this.container.querySelectorAll("input[name='_animal_select_mode']:checked")).map(el => el.value);
    //     this.ac_names.forEach((ac) => {
    //         let el = this.container.querySelector(`.animal-picker-mcs [name=${ac}]`);
    //         if (!el) return;
    //         if (values.includes(ac)) {
    //             el.closest(".mc-container").classList.toggle("is-hidden", false);
    //             el.disabled = false;
    //         } else {
    //             el.closest(".mc-container").classList.toggle("is-hidden", true);
    //             el.disabled = true;
    //         }
    //     });
    // }

    convertToIndividuals() {
        const mcIndividuals = this.multicompletes.get("individuals");
        const ac_data = new Map();
        // save the current values into convertable_data map
        let queries = []
        for (const key of this.acDataNames) {
            if (key === "individuals") continue;
            const mc = this.multicompletes.get(key);
            if(!mc) continue;
            ac_data.set(key, window.acGetValues(mc));
            // fetch individual ids from the multicompletes
            if (ac_data.get(key).length === 0) continue;
            queries.push(`${key}=${ac_data.get(key).join(",")}`)
        }
        axios.get(`/autocomplete/individuals_from_groups?${queries.join("&")}&pg_size=0`)
            .then((response) => {
                // add individual values to the individuals multicomplete
                window.acSetValues(mcIndividuals, response.data.individuals.map((i) => {return {value: i}}));
                this.acDataNames.forEach((key) => {
                    if (key === "individuals") return;
                    const mc = this.multicompletes.get(key);
                    if(!mc) return;
                    window.acClearValues(mc);
                });
                this.updateAnimalPicker();
            })
            .catch((error) => {
                console.error(error);
            });
    }

}